import { render, staticRenderFns } from "./Inventories.vue?vue&type=template&id=3d33c094&scoped=true"
import script from "./Inventories.vue?vue&type=script&lang=js"
export * from "./Inventories.vue?vue&type=script&lang=js"
import style0 from "./Inventories.vue?vue&type=style&index=0&id=3d33c094&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d33c094",
  null
  
)

export default component.exports